import { render, staticRenderFns } from "./StatusIcons.vue?vue&type=template&id=faca6e66&scoped=true"
import script from "./StatusIcons.vue?vue&type=script&lang=js"
export * from "./StatusIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faca6e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faca6e66')) {
      api.createRecord('faca6e66', component.options)
    } else {
      api.reload('faca6e66', component.options)
    }
    module.hot.accept("./StatusIcons.vue?vue&type=template&id=faca6e66&scoped=true", function () {
      api.rerender('faca6e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/StatusIcons.vue"
export default component.exports